module.exports = __webpack_public_path__ + "static/media/twitter.bfbdf618.svg";